import React from "react";

function MenuIconOpen() {
  return (
    <svg
      width={22.08}
      height={17.71}
      viewBox="0 0 22.08 17.71"
      overflow="visible"
    >
      <style>
        {
          ".prefix__st0{stroke-width:1.25}.prefix__st0,.prefix__st1{fill:none;stroke:#ff2839;stroke-miterlimit:10}"
        }
      </style>
      <path
        className="prefix__st0"
        d="M0 17.09h21.64M0 .62h21.64M0 11.6h9.42M0 6.05h9.42"
      />
      <path
        className="prefix__st1"
        d="M11.82 13.78l9.82-9.82M21.64 13.78l-9.82-9.82"
      />
      <g>
        <path
          className="prefix__st0"
          d="M11.82 13.78l9.82-9.82M21.64 13.78l-9.82-9.82"
        />
      </g>
    </svg>
  );
}

export default MenuIconOpen;
